// @ts-strict
import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { Location } from '@angular/common';
import {
  SohoApplicationMenuComponent,
  SohoBusyIndicatorDirective,
  SohoBusyIndicatorEvent,
  SohoModuleNavComponent,
  SohoModuleNavSwitcherComponent,
} from 'ids-enterprise-ng';
import {
  AppConstants,
  LMBrowserUtilService,
  LMCommonUtilService,
  LMConditionUtilService,
  LMContextUtilService,
  LMGlobalUtilService,
  LMLocaleUtilService,
  LMUniqueIdService,
} from './utils';
import {
  LMActionService,
  LMBusyIndicatorService,
  LMComponentInfoService,
  LMCompoundFieldService,
  LMConfigurationService,
  LMContextService,
  LMDataService,
  LMDrillService,
  LMErrorUtilService,
  LMFieldUtilService,
  LMFileUploadService,
  LMFormatUtilService,
  LMGlobalPersistenceService,
  LMListFilterPersistenceService,
  LMLoggerService,
  LMPersonalizationPersistenceService,
  LMRelatedReportService,
  LMSpecService,
  LMStateHelperService,
  LMStatePersistenceService,
  LMUrlInfoBuilderService,
  LMUrlUtilService
} from './services';
import {
  LMFormPersonalizationService,
  LMFormStateService,
  LMGlobalPersonalization,
  LMGlobalPersonalizationService,
  LMGlobalState,
  LMGlobalStateService,
  LMGlobalStorageService,
  LMListPersonalizationService,
  LMListStateService,
  LMPagePersonalizationService,
} from './states';
import {
  LMActionFormDialogService,
  LMApplicationMenuAsOfDateDialogService,
  LMApplicationMenuSearchComponent,
  LMApplicationMenuSearchService,
  LMApplicationMenuService,
  LMApplicationMenuTransactionService,
  LMApplicationMenuUserContextDialogService,
  LMApplicationMenuV3Component,
  LMCompactFormDialogService,
  LMComputeBuilderService,
  LMConfirmationMessageService,
  LMContextualActionPanelService,
  LMFieldPickerService,
  LMFormComponent,
  LMFormRequestService,
  LMFormSpecUtilService,
  LMHelperListDialogService,
  LMListActionUtilService,
  LMListContentFilterListUtilService,
  LMListGridPagingService,
  LMListGridUtilService,
  LMListTransactionService,
  LMListUtilService,
  LMLoginService,
  LMPrintDialogService,
  LMPrintRequestService,
  LMResponseRequiredService,
  LMScheduleDialogService,
  LMSelectDialogService,
  LMSubFormDialogService,
  LMSuiteHomeComponent
} from './components';
import { LMWebAppInitializerService } from '@services/webapp/lm-webapp-initializer.service';
import { LMFormTransactionService } from '@form/services/lm-form-transaction.service';
import { LMTransactionService } from './transaction';

import { isEmpty } from 'lodash-es';

import { SaveRequired } from '@base/lm-base';
import { LMBaseComponent } from '@base/lm-base.component';
import { LMRouteComponentService } from '@services/lm-route-component.service';
import { LMListActionFormDialogService } from '@list/services/lm-list-action-form-dialog.service';
import { LMPageStateService } from '@states/services/lm-page-state.service';
import { LMPageSpecUtilService } from '@page/lm-page-spec-util.service';
import { LMListSpecUtilService } from '@list/index';
import { LMAuditLogService } from '@services/lm-audit-log.service';
import { LMToolbarServiceAdapter } from '@toolbar/lm-toolbar-service-adapter';
import { LMNavigationService } from '@navigation/lm-navigation.service';
import { LMListContentFilterListService } from '@list/services/lm-list-content-filterlist.service';
import { LMFieldOptionsToolbarService } from '@field/services';
import { LMColorId, LMThemeId, LMThemeService } from '@banner/lm-theme.service';
import { Router } from '@angular/router';
import { LMFilterBuilderService } from '@modal/filter-builder/services/lm-filter-builder.service';
import { UserWebRequestHttpInterceptor } from './http.intercepter';
import { LMHttpIntercepterService } from '@services/lm-http-intercepter.service';
import { LMLplEditorService } from '@lplEditor/lm-lpl-editor.service';
import { LMKeyboardShortcutService, LMKeyType } from '@services/lm-keyboard-shortcut.service';
import { LMCubeCellRelService } from '@modal/cube-cell-rel/services';
import { LMFieldValidatorService } from '@modal/lm-field-validator.service';
import { fromEvent, Observable, Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { LMProcessIndicatorService } from './components/field/processindicator/lm-process-indicator.service';
import { LMProcessIndicatorTooltipPipe } from './components/field/processindicator/lm-process-indicator-tooltip.pipe';
import { LMApplicationMenuV1Component, LMApplicationMenuV2Component } from '@components/applicationmenu/menu';
import { LMApplicationMenuSubMenuService } from '@components/applicationmenu/submenu';
import { LMBusclassFieldService } from '@components/field/busclassfield/lm-busclassfield.service';
import { LMCaptchaControlService } from '@field/captchacontrol/lm-captcha-control.service';
import { LMListDropdownService } from '@components/lmlistdropdown';
import { LMAppComponentService } from '@utils/lm-app-component.service';
import {
  LMCreateReportDialogService,
  LMCreateReportSearchListDialogService,
  LMReportSecurityService,
  LMReportsCatalogService,
  LMReportPersonalizationDialogService
} from '@report/index';
import { LMBannerHeaderComponent } from './components/banner/lm-banner-header.component';
import { LMBannerHeaderComponentRef } from './components/banner/lm-banner-header-component-ref.service';
import { LMMenuSecurityService } from '@components/menusecurity';
import { LMGlobalTrackerService } from '@utils/lm-global-tracker.service';
import { ApplicationTracker } from '@yggdrasil/core';
import { LMDrillAroundService } from '@components/drillaround';
import { LMWebAppService } from '@services/lm-webapp.service';
import { LMSimpleProgressService } from './components/field/simpleprogress/lm-simple-progress.service';
import { LMBreadcrumbService } from '@services/lm-breadcrumb.service';
import { LMMenuLinkBoxService } from './services/lm-menu-link-box.service';
import { LMKeyboardShortcutsDialogService } from '@modal/lm-keyboard-shortcuts-dialog.service';

export const appComponentProviders: any[] = [
  LMApplicationMenuAsOfDateDialogService,
  LMApplicationMenuSubMenuService,
  LMApplicationMenuTransactionService,
  LMApplicationMenuService,
  LMApplicationMenuSearchService,
  LMApplicationMenuUserContextDialogService,
  LMBannerHeaderComponent,
  LMBannerHeaderComponentRef,
  LMBreadcrumbService,
  LMRouteComponentService,
  LMActionFormDialogService,
  LMActionService,
  LMAuditLogService,
  LMGlobalPersonalizationService,
  LMGlobalStateService,
  LMGlobalTrackerService,
  LMBrowserUtilService,
  LMBusyIndicatorService,
  LMCommonUtilService,
  LMCompactFormDialogService,
  LMCompoundFieldService,
  LMAppComponentService,

  LMConditionUtilService,
  LMConfirmationMessageService,
  LMContextUtilService,
  LMDataService,
  LMDrillService,
  LMDrillAroundService,
  LMErrorUtilService,
  LMContextualActionPanelService,

  LMFieldOptionsToolbarService,
  LMFieldUtilService,

  LMFieldPickerService,
  LMFilterBuilderService,

  LMFileUploadService,

  LMFormatUtilService,
  LMFormPersonalizationService,
  LMFormRequestService,
  LMFormSpecUtilService,
  LMFormStateService,
  LMFormTransactionService,

  LMGlobalPersonalizationService,
  LMGlobalStateService,
  LMGlobalStorageService,
  LMGlobalUtilService,
  LMHelperListDialogService,
  LMKeyboardShortcutService,
  LMKeyboardShortcutsDialogService,

  LMContextualActionPanelService,
  LMListActionUtilService,
  LMListActionFormDialogService,
  LMListContentFilterListService,
  LMListContentFilterListUtilService,
  LMListGridPagingService,
  LMListGridUtilService,
  LMListPersonalizationService,
  LMListSpecUtilService,
  LMListStateService,
  LMListTransactionService,
  LMListUtilService,

  LMLocaleUtilService,
  LMLoggerService,
  LMLoginService,
  LMGlobalPersistenceService,
  LMNavigationService,

  LMPagePersonalizationService,
  LMPageSpecUtilService,
  LMPageStateService,

  LMPersonalizationPersistenceService,
  LMPrintDialogService,
  LMPrintRequestService,
  LMReportPersonalizationDialogService,
  LMResponseRequiredService,
  LMScheduleDialogService,
  LMSelectDialogService,
  LMSpecService,
  LMWebAppService,
  LMStatePersistenceService,
  LMStateHelperService,
  LMSubFormDialogService,
  LMToolbarServiceAdapter,
  LMThemeService,
  LMUrlInfoBuilderService,
  LMTransactionService,
  LMUrlUtilService,
  LMConfigurationService,
  LMRelatedReportService,
  LMComponentInfoService,
  LMUniqueIdService,
  UserWebRequestHttpInterceptor,
  LMLplEditorService,
  LMListDropdownService,
  LMCubeCellRelService,
  LMFieldValidatorService,
  LMComputeBuilderService,
  LMProcessIndicatorService,
  LMProcessIndicatorTooltipPipe,
  LMBusclassFieldService,
  LMCaptchaControlService,
  LMListFilterPersistenceService,
  LMCreateReportDialogService,
  LMCreateReportSearchListDialogService,
  LMReportsCatalogService,
  LMReportSecurityService,
  LMMenuSecurityService,
  LMSimpleProgressService,
  LMMenuLinkBoxService
];

export interface AppMenuComponent {
  version: 'v1' | 'v2' | 'v3';
  component: LMApplicationMenuV1Component | LMApplicationMenuV2Component | LMApplicationMenuV3Component;
  header: ElementRef;
  // eslint-disable-next-line @typescript-eslint/ban-types
  loadWebAppMenu: Function;
  moduleNavSwitcher: SohoModuleNavSwitcherComponent | null;
}

export interface AppMenuSearchComponent {
  version: 'v1' | 'v2' | 'v3';
  component: LMApplicationMenuSearchComponent;
}

@Component({
  selector: 'lm-app',
  styleUrls: [ 'app.component.scss' ],
  templateUrl: './app.component.html'
  })
export class AppComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {
  @ViewChild(LMBaseComponent) private baseComponent: LMBaseComponent | undefined;
  @ViewChild('SohoApplicationMenu') private sohoApplicationMenuComponent: SohoApplicationMenuComponent | undefined;
  @ViewChild('SohoApplicationMenuSearch') private sohoApplicationMenuSearchComponent: SohoApplicationMenuComponent | undefined;
  @ViewChild(LMBannerHeaderComponent) private _bannerHeaderComponent: LMBannerHeaderComponent | undefined;
  @ViewChild(LMApplicationMenuV1Component) private applicationMenuV1Component: LMApplicationMenuV1Component | undefined;
  @ViewChild(LMApplicationMenuV2Component) private applicationMenuV2Component: LMApplicationMenuV2Component | undefined;
  @ViewChild(LMApplicationMenuV3Component) private applicationMenuV3Component: LMApplicationMenuV3Component | undefined;
  @ViewChild(LMApplicationMenuSearchComponent) private applicationMenuSearchComponent: LMApplicationMenuSearchComponent | undefined;

  @ViewChild(SohoBusyIndicatorDirective, { static: false }) sohoBusyIndicator!: SohoBusyIndicatorDirective;
  @ViewChild('dialogPlaceholder', { read: ViewContainerRef, static: true }) placeHolder!: ViewContainerRef;
  @ViewChild('fullmaincontent', { read: ViewContainerRef, static: true }) fullmaincontent!: ViewContainerRef;
  @ViewChild('SohoModuleNav') sohoModuleNavComponent: SohoModuleNavComponent | undefined;

  @HostBinding('class.no-scroll') get disallowOverflow() {
    return this.noScroll;
  }

  @HostBinding('class.modal-engaged') get modalEngaged() {
    return this.showOverlay;
  }

  @HostBinding('class.hasHeaderTabs') get headerTabs() {
    return this.hasHeaderTabs;
  }

  @HostListener('window:beforeunload', [ '$event' ]) beforeUnloadHander() {
    // let dialogText = 'Dialog text here';
    //  event.returnValue = dialogText;
    console.log('@HostListener("window:beforeunload)"');
    this.docCookies = document.cookie;

    // if the Application tracker exist stop the tracking.
    const applicationTracker: ApplicationTracker = this.lmGlobalTrackerService.getApplicationTracker();
    if (applicationTracker) {
      applicationTracker.trackEnd();
    }

    const component: SaveRequired = this.getRouteComponent();
    // todo sjw lets use an interface here that the top level components must implement.
    // todo sjw saveComponentState isn't generic enough, maybe componentWillUnload()??
    if (component) {
      component.saveComponentState(true);
      const isSave = !component.checkSaveRequired();
      return isSave;
    } else {
      // when component is null, since it's not a router outlet like access denied, returns true so the dialog is not prompted
      return true;
    }
  }

  @HostListener('window:pageshow', [ '$event' ]) onPageShow(event: PageTransitionEvent) {
    // Limited number of pages are persisted in bfcache.
    // Turning off caching using Cache control meta will also prevent spec from caching.
    // Instead, in case a page is retrieved from cache, reload if the cookie string is different.
    // C.LWSN is httpOnly cookie. SSO.CSRF can be read in JS, and it will be different when user logs out.
    if (event.persisted) {
      if (document.cookie && this?.docCookies && document.cookie !== this.docCookies) {
        // console.log('@HostListener("window:pageshow:persisted - reload)"');
        window.location.reload();
      }
    }
  }

  @HostListener('document:keydown', [ '$event' ]) onKeyDown(e: KeyboardEvent) {
    // TODO check to make sure a modal isn't open.
    if (!this.hideAppMenu) {
      const key = this.lmKeyboardShortcutService.onKeyDown(e);
      if (!key) {
        return;
      }

      if (this.sohoApplicationMenuComponent && key === LMKeyType.MENU) {
        if (this.sohoApplicationMenuSearchComponent && this.sohoApplicationMenuSearchComponent.isOpen()) {
          this.menuSearchMode = false;
          this.sohoApplicationMenuComponent.triggers = [ '.application-menu-trigger' ];
          this.sohoApplicationMenuComponent.openMenu(undefined, true, undefined);
        } else {
          if (this.sohoApplicationMenuComponent.isOpen()) {
            this.openOnLarge = false;
            this.sohoApplicationMenuComponent.closeMenu();
          } else {
            this.sohoApplicationMenuComponent.triggers = [ '.application-menu-trigger' ];
            // LMCLIENT-29807 appear to be hitting a timing issue when doing the openMenu. added setTimeout().
            this.ngZone.runOutsideAngular(() => {
              setTimeout(() => {
                if (this.sohoApplicationMenuComponent) {
                  this.sohoApplicationMenuComponent.openMenu(undefined, true, undefined);
                }
              }, 1);
            });
          }
        }
      }

      if (this.sohoModuleNavComponent && key === LMKeyType.MENU) {
        this.onAppMenuTriggerEvent();
      }
    }
  }

  private showOverlay = false;
  private noScroll = true;

  public hideAppMenu = false;
  public hideTitle = false;
  public useMingleStartMode = false;
  public inMingle = false;
  public mingleStartModeCompleted = false;
  public inMingleInbox = false;
  public inMingleOverlay = false;
  public inMingleWidget = false;
  public hasHeaderTabs = false;
  public hasBreadcrumbs = false;
  public webAppsLoaded = false;
  public accessibleWebApps: LMWebAppSpec[] = [];
  public searchString = '';
  public localeLoaded = false;
  public menuSearchMode = false;
  public menuSearchResultsByWebApp?: LMBannerSearchResults;
  public dataSearchResults?: LMBannerSearchResult[];
  public reportSearchResults?: LMBannerSearchResult[];
  public systemSearchResults?: LMBannerSearchResult[];
  public menuItemSearch?: LMApplicationMenuButton[];
  public menuSpecsByWebApp?: LMWebAppSpec[];
  public inUpliftTheme = true;
  public asOfDate: string;
  public showArchive = false;
  public showDeletedRecords = false;
  public useFullPageScrolling = false;
  private fPSChanged = false;
  private m_useFPScrolling = false;
  public showViewMoreNav = false;
  public onMobile = true;
  public openOnLarge = false;
  public uiLoadingIndicatorTimeout = 0;
  public applyColorToMenu = true;
  public bannerInRoute = false;
  public drillAroundWindow = false;
  public moduleNavDisplayMode: SohoModuleNavDisplayMode = this.getInitialModuleNavDisplayMode();
  public contentHeight = '';
  public insideInforGo = false;
  public mingleMode = false;

  /**
   *  V1 = Original banner menu
   *  v2 = New application menu
   */
  public menuIsV1 = false;
  public menuIsV2 = false;
  public menuIsV3 = false;

  public skipToMainContentLabel = 'skip to main content'; // todo i18n me!

  private globalState: LMGlobalState = {};
  private lmKeyDownObservable!: Observable<Event>;
  private takeUntilSubject$!: Subject<void>;

  private docCookies?: string;

  constructor(
    private location: Location,
    private ngZone: NgZone,
    private router: Router,
    private lmBusyIndicatorService: LMBusyIndicatorService,
    private lmContextService: LMContextService,
    private lmContextUtilService: LMContextUtilService,
    private lmGlobalUtilService: LMGlobalUtilService,
    private lmUrlUtilService: LMUrlUtilService,
    private lmErrorUtilService: LMErrorUtilService,
    private currentComponent: LMRouteComponentService,
    private lmGlobalPersonalizationService: LMGlobalPersonalizationService,
    private lmGlobalStateService: LMGlobalStateService,
    private lmGlobalTrackerService: LMGlobalTrackerService,
    private lmLoggerService: LMLoggerService,
    private lmThemeService: LMThemeService,
    private lmKeyboardShortcutService: LMKeyboardShortcutService,
    private lmHttpIntercepterService: LMHttpIntercepterService,
    private lmBrowserUtilService: LMBrowserUtilService,
    private lmFormatUtilService: LMFormatUtilService,
    private lmApplicationMenuService: LMApplicationMenuService,
    private lmAppComponentService: LMAppComponentService,
    private lmWebAppInitializerService: LMWebAppInitializerService

  ) {
    this.menuIsV1 = this.lmContextService.isApplicationMenuV1();
    this.menuIsV2 = this.lmContextService.isApplicationMenuV2();
    this.menuIsV3 = this.lmContextService.isApplicationMenuV3();

    // Method Cypress will call
    if ((window as any).Cypress) {
      (window as any).cypressNavigateByUrl = (url: string) => this.cypressNavigateByUrl(url);
    }

    // --------------------------------------------------------------------
    // bootstrap values sent in the html file into a these services.
    // This allows us to mock these services for testing.
    // --------------------------------------------------------------------
    this.lmBusyIndicatorService.appComponent = this;

    this.lmUrlUtilService.setBannerSpecUrlTemplate(bannerSpecUrl);
    this.lmUrlUtilService.setAccessibleWebAppsUrlTemplate(accessibleWebAppsUrl);

    this.hideAppMenu = this.lmContextService.inMingleWidget()
      || this.lmContextService.inMingleOverlay()
      || this.lmContextService.inMingleInbox()
      || this.lmContextService.isUnified()
      || this.lmContextService.isHideMenuBar()
      || this.lmContextService.drillAroundWindow();

    this.hideTitle = this.lmContextService.inMingleOverlay() || this.lmContextService.isHideTitlebar();
    this.useMingleStartMode = this.lmContextService.useMingleStartMode();
    this.inMingle = this.lmContextService.inMingle();
    this.mingleStartModeCompleted = this.lmContextUtilService.hasStartModeCompleted();
    this.inMingleWidget = this.lmContextService.inMingleWidget();
    this.inMingleInbox = this.lmContextService.inMingleInbox();
    this.inMingleOverlay = this.lmContextService.inMingleOverlay();
    this.onMobile = this.lmContextService.isMobileDevice();
    this.uiLoadingIndicatorTimeout = this.lmContextService.uiLoadingIndicatorTimeout;
    this.bannerInRoute = this.lmContextService.isBannerInRoute();
    this.drillAroundWindow = this.lmContextService.drillAroundWindow();
    // load global state here as getInitialAsOfDate needs it.
    this.loadGlobalState();

    // get the initial as of date based on the bootstrap html context object
    // or the as of date in global state.
    this.asOfDate = this.getInitialAsOfDate();
    this.checkAsOfDateInPast(this.asOfDate);
    this.setupShowDeletedRecords();
    this.initializeArchiveMode();

    // todo refactor asof date once the new spec urls are solely in place.
    //  once we refactor to only send a asofdate (and not a csk.asofdate) on data urls,
    //  we should only need to the commented code below to deal with the initial setting
    //  of the asofdate from the bootstrap global context
    // // If asofdate is set it means it came in from a url param through the bootstrap global context.
    // // in that case replace the url in the history so csk.asofdate is no longer on it.
    // // We need this to avoid the user being able to go back to a url that has as of date set on it.
    // const newUrl = this.lmUrlUtilService.removeParam(window.location.href, AppConstants.PARAM_CSK_ASOFDATE);
    // this.location.replaceState(this.lmUrlUtilService.toRelativeUrl(newUrl));

    // todo refactor asof date once the new spec urls are solely in place.
    //  this code shoudl not be needed once we refactor to only send a asofdate
    //  (and not a csk.asofdate) on data urls.
    // ensure that csk.asofdate is always removed from the browser
    // url when using server side generated spec urls

    this.location.onUrlChange(url => {
      if (this.lmUrlUtilService.hasParam(url, AppConstants.PARAM_CSK_ASOFDATE)
      ||  this.lmUrlUtilService.hasParam(url, AppConstants.PARAM_CSK_SHOWDELETEDRECORDS)
      ||  this.lmUrlUtilService.hasParam(url, AppConstants.PARAM_CSK_VIEWARCHIVE)) {
        const newUrl = this.lmUrlUtilService.removeParams(url, [ AppConstants.PARAM_CSK_ASOFDATE, AppConstants.PARAM_CSK_SHOWDELETEDRECORDS, AppConstants.PARAM_CSK_VIEWARCHIVE ]);
        this.location.replaceState(this.lmUrlUtilService.toRelativeUrl(newUrl));
      }

      if (!this.hideAppMenu) {
        /**
         * https://jira.infor.com/browse/LMWEB-18948
         * Caused by timing issue from initial load and reload of menu via this.location.onUrlChange.
         * Not sure exactly what recent change is causing this to fail on QA server.
         * We suspect it might have something to do with new security changes on menus.
         * Possibly causing a larger menu to have a longer response time.
         * When logging I was seeing that the LPAAdmin menu would sometimes load in faster than the page it was redirected from.
         * Employee or Manager for example.
         *
         * loadMenu() gets fired from initial load via app menu ngAfterViewInit(). And also syncWebappMenu()
         * sometimes syncWebappMenu() will load first causing the wrong menuItemSpecs to load
         * syncWebappMenu() should load last
         */
        setTimeout( () => this.syncWebappMenu(url), 100);
      }
    });

    const options = [
      ...(this.inMingleWidget ? [ 'inMingleWidget', true ] : [])
    ];

    this.lmLoggerService.log([ 'Starting Infor Landmark Xi', new Date(), ... options ]);

    if (this.inMingleWidget) {
      document.getElementsByTagName('body')[ 0 ].classList.add('in-mingle-widget');
    }

    if (this.lmContextService.inMingle()) {
      this.takeUntilSubject$ = new Subject<void>();
    }

    setTimeout(() => {
      // -----------------------------------------------------------------
      // Need to place this in a timeout in case we need to bring up the
      // access denied dialog. If we don't then angular will close it
      // destroy it since angular is in the middle of navigating to this
      // component.
      // -----------------------------------------------------------------
      if (this.lmWebAppInitializerService.hasError()) {
        this.lmErrorUtilService.handleUnexpectedError(this.lmWebAppInitializerService.getError(), this.placeHolder);
      } else {
        const webAppSpecs: LMWebAppSpec[] = this.lmWebAppInitializerService.getAccessibleWebApps();
        this.lmContextService.setAccessibleWebApps(webAppSpecs);
        try {
          this.lmContextService.getCurrentWebAppSpec();
          this.webAppsLoaded = true;
        } catch (e) {
          this.lmErrorUtilService.showAccessDeniedError(e, this.placeHolder);
        }
      }
    });

    this.lmHttpIntercepterService.run(this.lmContextService.getContext());
    this.lmAppComponentService.setAppComponent(this);

 //   this.lmGlobalUtilService.enableAutomatictracking();
  }

  public cypressNavigateByUrl(url: string) {
    this.ngZone.run(() => {
      // this.lmGlobalUtilService.navigate(url)
      this.router.navigateByUrl(url);
    });
  }

  public getSohoApplicationMenuComponent(): SohoApplicationMenuComponent | undefined {
    return this.sohoApplicationMenuComponent;
  }

  /**
   * returns an initial as of date of either what's passed into the bootstrap
   * html through a csk.asofdate param or what's in the LMGlobalState object.
   * If the date of the csk doesn't match teh date of globalstate object then
   * the csk will be used and the global state will be updated.
   */
  private getInitialAsOfDate(): string {
    const ctxAsOfDate = this.lmContextService.getAsOfDate();

    // ------------------------------------------------------------------
    // if state is disabled then never use the asofdate from state.
    // ------------------------------------------------------------------
    if (this.lmContextService.disablePageState()) {
      return ctxAsOfDate || '';
    }

    // ------------------------------------------------------------------
    // if there is an asofdate in the context then use that.
    // ------------------------------------------------------------------
    if (ctxAsOfDate) {
      if (!this.globalState.asOfDate || this.globalState.asOfDate !== ctxAsOfDate) {
        // ------------------------------------------------------------------
        // if there is not a globalState AsOfDate ore  it doesn't match
        // the ctxAsOfDate then update the globalState with the new value
        // ------------------------------------------------------------------
        this.globalState.asOfDate = ctxAsOfDate;
        this.saveGlobalState();
      }
      return ctxAsOfDate;
    }

    // ------------------------------------------------------------------
    // if not in the context but in global state then use that.
    // ------------------------------------------------------------------
    if (this.globalState.asOfDate) {
      this.lmContextService.setAsOfDate(this.globalState.asOfDate);
      return this.globalState.asOfDate;
    }

    return '';
  }

  /**
   * returns an initial showRecordsDoNotExist of either what's passed into the bootstrap
   * html through a csk param or what's in the LMGlobalState object.
   */
  private setupShowDeletedRecords(): void {
    if (!this.lmContextService.isConfigFeatureEnabled(AppConstants.FEATURE_ShowDeletedRecords)) {
      return;
    }
    this.showDeletedRecords = this.globalState.showdeletedrecords || false;
    this.lmContextService.setShowDeletedRecords(this.showDeletedRecords);
  }

  private initializeArchiveMode() {
    if (!this.lmContextService.isConfigFeatureEnabled(AppConstants.FEATURE_ShowArchive)) {
      return;
    }

    let ctxArchiveMode = undefined;
    const contextSessionKeys = this.lmContextService?.getContext()?.contextSessionKeys;
    if (contextSessionKeys) {
      ctxArchiveMode = contextSessionKeys[AppConstants.PARAM_CSK_VIEWARCHIVE];
      if (ctxArchiveMode !== undefined) {
        ctxArchiveMode = ctxArchiveMode === 'true'; // any string other than 'true' is false;
      }
    }
    this.showArchive = ctxArchiveMode === undefined ? !!this.globalState?.archiveMode : ctxArchiveMode;

    this.globalState.archiveMode = this.showArchive;
    this.lmGlobalStateService.saveGlobalState(this.globalState);

    this.lmContextService.setArchiveMode(this.showArchive);
  }

  ngOnInit() {
    this.mingleMode = this.lmContextService.inMingle();
    this.insideInforGo = this.lmContextService.insideInforGo();
    this.setPersonalizations();
    this.searchString = Soho.Locale.translate('Search');
  }

  ngAfterViewInit() {
    /**
     * ngAfterViewInit is executed outside the angular zone.
     * Must be placed in a timeout so that an openOnLarge change will
     * get picked up by change detection.
     */
    setTimeout(() => this.setMenuPersonalization());

    /**
     * hookup the app menu trigger once the afterViewInit is called. This will
     * ensure that the lm-toolbar has had a chance to create the application-menu-trugger
     * button.
     */
    if (!this.inMingleWidget
      && this.sohoApplicationMenuComponent
      && !this.lmContextService.isHideMenuBar()
      && !this.lmContextService.isUnified()
    ) {
      this.sohoApplicationMenuComponent.triggers = [ '.application-menu-trigger' ];
    }

    if (this.lmBrowserUtilService.isIE11 && !this.lmContextService.inMingle()) {
      const title = Soho.Locale.translate('UnsupportedBrowser');
      const message = Soho.Locale.translate('UnsupportedBrowserMsg');
      this.lmGlobalUtilService.displayToastMessage(title, message, 'UnsupportedBrowser');
    }

    // LMRK-102637: Listen to keydown to set mingle activity cookie (recruiter taking notes during interview, no new requests)
    // LMWEB-2494: Mingle activity cookie will be updated in http interceptor as well (for users that are just browsing)
    if (this.lmContextService.inMingle()) {
      this.lmKeyDownObservable = fromEvent(document, 'keypress');
      this.lmKeyDownObservable.pipe(takeUntil(this.takeUntilSubject$), debounceTime(3000)).subscribe(() => {
        this.lmContextService.setMingleActivityCookie();
      });
    }
  }

  ngAfterViewChecked() {
    if (this.fPSChanged) {
      this.fPSChanged = false;

      if (this.useFullPageScrolling !== this.m_useFPScrolling) {
        setTimeout(() => this.useFullPageScrolling = this.m_useFPScrolling, 1);
      }
    }
  }

  ngOnDestroy(): void {
    this.lmThemeService.getThemeChangeSubject().unsubscribe();
    if (this.lmContextService.inMingle()) {
      this.takeUntilSubject$.next();
      this.takeUntilSubject$.complete();
    }
  }

  getRouteComponent(): any {
    return this.currentComponent.getRouteComponent();
  }

  public onActivate() {
    const url = this.router.url;

    if (this.inMingleWidget && (url.indexOf('nav=') >= 0 || url.indexOf('/list/') >= 0)) {
      this.ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          this.showViewMoreNav = true;
        }, 1);
      });
    }

    this.removeMingleStartModeOverlay();
  }

  public onMenuLoaded(event: MouseEvent) {
    if (this.sohoApplicationMenuComponent) {
      this.sohoApplicationMenuComponent.updateLazy(this.sohoApplicationMenuComponent, event.target);
    }
    if (this.sohoModuleNavComponent) {
      this.sohoModuleNavComponent.updateLazy(this.sohoModuleNavComponent, event.target);
    }
  }

  public onWebAppMenuLoaded(webAppMenuLoadedEvent: WebAppMenuLoadedEvent) {
    // TODO: WebAppMenuSecurityOptimization We may want to test this out for OCT24
    // this.webAppsLoaded = true;
    const roleSwitcherMode = webAppMenuLoadedEvent.roleSwitcher;
    const menuComponent = this.getMenuComponent();
    const webAppMenuHeader = menuComponent?.header;

    // V1,V2
    if (this.sohoApplicationMenuComponent && menuComponent) {
      const applicationMenu = this.sohoApplicationMenuComponent;

      if (webAppMenuHeader) {
        this.expandPreviouslyOpenedMenus();

        if (!webAppMenuHeader.nativeElement.classList.contains('is-expanded')) {
          this.sohoApplicationMenuComponent.toggleAndSelectHeader(applicationMenu, webAppMenuHeader.nativeElement);
        }
      } else {
        if (roleSwitcherMode) {
          this.sohoApplicationMenuComponent.updated();
          this.expandPreviouslyOpenedMenus();
        }
      }
    }

    // V3
    if (this.sohoModuleNavComponent && menuComponent) {
      this.expandPreviouslyOpenedMenus();
      this.sohoModuleNavComponent.updated({ displayMode: this.lmContextService.isMobileDevice() ? false : this.moduleNavDisplayMode });
    }
  }

  private expandPreviouslyOpenedMenus() {
    if (this.menuIsV3) {
      const expandedMenus = this.lmGlobalPersonalizationService.getGlobalPersonalization().expandedMenus;

      // Expand and select previously expanded menu
      if (expandedMenus && expandedMenus.length > 0) {
        expandedMenus.forEach((menuIndex, index) => {
          const header = jQuery(`[menuindex="${menuIndex}"]`);
          const accordionAPI = this.sohoModuleNavComponent?.accordionAPI();

          // Only select last item
          if (index === expandedMenus.length -1) {
            accordionAPI?.select(header);
          }

          accordionAPI?.expand(header);
        });
      }
    } else {

      const expandedMenus = this.lmApplicationMenuService.getExpandedMenus();

      if (expandedMenus && expandedMenus.length > 0) {
        expandedMenus.forEach((menuIndex) => {
          // TODO: move to ids-enterprise-ng
          const accordionElement = jQuery(`[menuindex='${menuIndex}']`);

          if (!accordionElement.data('accordion')) {
            this.ngZone.runOutsideAngular(() => accordionElement.accordion());
          }

          const accordionControl = accordionElement.data('accordion');
          if (accordionControl) {
            this.ngZone.runOutsideAngular(() => accordionControl.expand(accordionElement, true));
          }

          if (accordionElement.attr('selected')) {
            this.ngZone.runOutsideAngular(() => accordionControl.select(accordionElement));
          }
        });
      }
    }
  }

  public onMenuVisibility(visible: boolean) {
    const bannerPersonalization: LMGlobalPersonalization = this.lmGlobalPersonalizationService.getGlobalPersonalization();

    bannerPersonalization.isMenuOpen = visible;
    this.lmGlobalPersonalizationService.saveGlobalPersonalization(bannerPersonalization);
  }

  public onAccordionExpand(result: any) {
    if (result) {
      const menuHeader = result[0];
      const webAppName = menuHeader.getAttribute('web-app-name');
      // const webAppId = menuHeader.getAttribute('id');

      if (webAppName) {
        const menuComponent = this.getMenuComponent();
        if (!menuComponent) {
          console.log('AppComponent.onAccordionExpand - unable to get MenuComponent');
          return;
        }

        menuComponent.component.loadWebAppMenu(menuHeader);
      }
    }
  }

  public onSearchMenuVisibility() {
    if (!this.sohoApplicationMenuSearchComponent) {
      return;
    }
    if (!this.sohoApplicationMenuSearchComponent.isOpen()) {
      this.menuSearchMode = false;
      if (this.sohoApplicationMenuComponent) {
        this.sohoApplicationMenuComponent.triggers = [ '.application-menu-trigger' ];
      }
    }
  }

  private updateThemeIcons(themeId: LMThemeId) {
    if (this.lmThemeService.isUpliftTheme(themeId)) {
      this.inUpliftTheme = true;
    } else {
      this.inUpliftTheme = false;
    }
  }

  public onAsOfDateChanged(date: string) {
    if (date === '' || date === '00000000') {
      this.onAsOfDateCleared();
      return;
    }
    this.lmContextService.setAsOfDate(date);
    this.checkAsOfDateInPast(date);
    this.asOfDate = date;

    this.globalState.asOfDate = date;
    this.lmGlobalStateService.saveGlobalState(this.globalState);

    // force a reload of the route so that asofdate can be taken into
    // account by the route component (List, Form, Page, etc...).
    this.forceLocationReload();
  }

  private checkAsOfDateInPast(date: string): void {
    // only check if asOfDate in past if asOfDate is set
    if (!date || date.toString().length === 0) {
      return;
    }
    const today = new Date();
    // Need to get the date object from Soho.Locale.parseDate, otherwise the locale isn't taken into account
    // and new Date returns an invalid when not in USA date format
    const asOfDate = Soho.Locale.parseDate(this.lmFormatUtilService.yyyymmddToDisplay(date));
    if (asOfDate < today) {
      this.lmContextService.setAsOfDateInPast(true);
    } else {
      this.lmContextService.setAsOfDateInPast(false);
    }
  }

  public onAsOfDateCleared() {
    this.lmContextService.clearAsOfDate();
    this.lmContextService.setAsOfDateInPast(false);
    this.asOfDate = '';

    delete this.globalState.asOfDate;
    this.lmGlobalStateService.saveGlobalState(this.globalState);
    const globalPersonalization = this.lmGlobalPersonalizationService.getGlobalPersonalization();
    globalPersonalization.asOfDate = '';
    // force a reload of the route so that asofdate can be taken into
    // account by the route component (List, Form, Page, etc...).
    this.forceLocationReload();
  }

  public onQuitArchiveView() {
    if (this.showArchive === false && this._bannerHeaderComponent !== undefined) {
      // List locally entered archive mode but did not force a reload for app component to be initialized again
      // Setting this.showArchive to false will not trigger change detection to remove red bar from toolbar
      this._bannerHeaderComponent.showArchive = false;
    }
    this.showArchive = false;
    this.lmContextService.setArchiveMode(false);

    // This line should always be above (this.lmGlobalStateService.saveGlobalState(this.globalState))
    // to get the current value of lastClickedMenuUrl 
    const lastClickedMenuUrl = this.lmGlobalStateService.getGlobalState()?.lastClickedMenuUrl;

    delete this.globalState.archiveMode;
    this.lmGlobalStateService.saveGlobalState(this.globalState);
    
    let url = '';
    if (this._bannerHeaderComponent?.breadcrumbs?.length > 1) {
      url = this._bannerHeaderComponent.breadcrumbs[0]?.href || `${this.lmUrlUtilService.getBaseUrl()}/home`;
      this._bannerHeaderComponent.resetBreadCrumbs(this._bannerHeaderComponent.getCurrentCategory());
    } else if (lastClickedMenuUrl) {
      // if breadcrumbs is disabled
      url = lastClickedMenuUrl;
    } else if (this.getRouteComponent() instanceof LMFormComponent) {
      url = `${this.lmUrlUtilService.getBaseUrl()}/home`;
    } 
    
    if (url) {
      url = this.lmUrlUtilService.removeParam(url, AppConstants.PARAM_CSK_VIEWARCHIVE);
      this.lmGlobalUtilService.navigateByUrl(url, { replaceUrl: true });
    } else {
      this.forceLocationReload();
    }
  }

  public onQuitDBSessionDebugMode() {
    const locationHref = this.location.path(true);
    const nonDBSessionDebugModeUrl = this.lmUrlUtilService.updateUrlParams(locationHref, { 'csk.dbsessiondebug': undefined, 'csk.dbsessiondebuglevel': undefined, 'csk.lpltrace': undefined });
    this.lmGlobalUtilService.navigate(nonDBSessionDebugModeUrl);
  }

  public onQuitSecSessionDebugMode() {
    const locationHref = this.location.path(true);
    const nonSecSessionDebugModeUrl = this.lmUrlUtilService.updateUrlParams(locationHref, { 'csk.secsessiondebug': undefined });
    // this.lmGlobalUtilService.navigateByUrl(nonSecSessionDebugModeUrl, { replaceUrl: true });
    this.lmGlobalUtilService.navigate(nonSecSessionDebugModeUrl);
  }

  public showDeletedRecordsCleared() {
    this.showDeletedRecordsChanged(false);
  }

  public showDeletedRecordsChanged(on: boolean) {
    this.lmContextService.setShowDeletedRecords(on);
    this.globalState.showdeletedrecords = on;
    this.lmGlobalStateService.saveGlobalState(this.globalState);

    // force reload of the route so that showdeleterrecords can be taken into
    // account by the route component (List, Form, Page, etc...).
    // this.forceLocationReload();
    this.lmGlobalUtilService.navigate(window.location.href, null, 'replace');
  }

  private forceLocationReload(): void {
    this.lmGlobalUtilService.navigateByUrl(window.location.href, { replaceUrl: true });
  }

  public fullPageScrolling(useFPS: boolean) {
    this.fPSChanged = true;
    this.m_useFPScrolling = useFPS;
  }

  public onSystemMenuItemClick(event: LMApplicationMenuSearchResult) {
    this.getMenuComponent()?.component?.onSystemMenuItemClick(event);
  }

  public onMenuSearched(event: LMBannerSearchEvent) {
    this.menuSearchMode = true;
    this.menuSpecsByWebApp = event.menuSpecsByWebApp;
    this.menuSearchResultsByWebApp = event.menuSearchResultsByWebApp;
    this.dataSearchResults = event.dataSearchResults;
    this.reportSearchResults = event.reportSearchResults;
    this.systemSearchResults = event.systemSearchResults;
    this.menuItemSearch = event.menuItemSearch;
    this.searchString = event.searchString;

    // no need for change detection here. put setTimeout
    // outside Angular so change detection won't be fired.
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        if (this.sohoApplicationMenuComponent && this.sohoApplicationMenuSearchComponent) {
          this.sohoApplicationMenuComponent.closeMenu();
          this.sohoApplicationMenuSearchComponent.openMenu(undefined, true, undefined);

          const applicationMenuSearch = this.sohoApplicationMenuSearchComponent;

          const searchMenuComponent = this.getSearchMenuComponent();
          if (!searchMenuComponent) {
            console.log('AppComponent.onMenuSearched - unable to get searchMenuComponent');
            return;
          }

          const searchMenuHeaders = searchMenuComponent.component.searchMenuHeaders;
          if (searchMenuHeaders) {
            const header = searchMenuHeaders.toArray()[ 0 ];
            if (header) {
              if (this.isHeaderExpanded(header)) {
                this.sohoApplicationMenuSearchComponent.updated();
              } else {
                this.sohoApplicationMenuSearchComponent.toggleAndSelectHeader(applicationMenuSearch, header.nativeElement);
              }
            }
          } else {
            this.sohoApplicationMenuSearchComponent.updated();
          }
        }

        if (this.sohoModuleNavComponent) {
          const searchMenuComponent = this?.getMenuComponent()?.component?.applicationMenuSearchComponent;
          if (!searchMenuComponent) {
            console.log('AppComponent.onMenuSearched - unable to get searchMenuComponent');
            return;
          }

          const searchMenuHeaders = searchMenuComponent.searchMenuHeaders;
          if (searchMenuHeaders) {
            if (this.lmContextService.isApplicationMenuV3()) {
              searchMenuComponent.setHeaderTitles(this.systemSearchResults, this.reportSearchResults, this.dataSearchResults);
            }
            const header = searchMenuHeaders.toArray()[0];
            this.sohoModuleNavComponent?.accordionAPI()?.updated();
            header?.nativeElement?.click();
          } else {
            this.sohoModuleNavComponent?.accordionAPI()?.updated();
          }
        }
      });
    });
  }

  public onMenuSearchCleared() {
    if (this.sohoApplicationMenuComponent) {
      this.menuSearchMode = false;

      this.sohoApplicationMenuComponent.triggers = [ '.application-menu-trigger' ];
      this.sohoApplicationMenuComponent.openMenu(undefined, true, undefined);

      this.menuSearchResultsByWebApp = {};
      this.dataSearchResults = [];
      this.reportSearchResults = [];
      this.systemSearchResults = [];

      const menuComponent = this.getMenuComponent();
      if (!menuComponent) {
        console.log('AppComponent.onMenuSearchCleared - unable to get MenuComponent');
        return;
      }


      if (this.lmApplicationMenuService.hasExpandedMenus() && this.lmApplicationMenuService.getExpandedMenus().length > 0) {
        this.lmApplicationMenuService.getExpandedMenus().forEach((menuIndex) => {
          this.ngZone.runOutsideAngular(() => {
            /**
             * TODO: Create ids-enterprise example for dynamically adding/removing HTML from the Application menu...
             * Timeout because of a timing conflict with ids-enterprise Application menu control
             * when search closes or opens the application menu, it then causes updateRequired to be flagged in ids-enterprise-ng wrapper
             * this then triggers an update event "this.applicationmenu.updated()" in ngAfterViewChecked(),
             * update then does a full rebuild of the application menu, which causes the panes to rebuild/toggle when they are already open
             */
            setTimeout(() => {
              const lmBannerMenuElement = document.querySelectorAll('[menuindex="' + menuIndex + '"]')[0]?.nextElementSibling as HTMLElement;
              if (lmBannerMenuElement) {
                lmBannerMenuElement.style.height = 'auto';
              }
            }, 1);
          });
        });
      }
    }

    if (this.sohoModuleNavComponent) {
      this.menuSearchMode = false;
      this.menuSearchResultsByWebApp = {};
      this.dataSearchResults = [];
      this.reportSearchResults = [];
      this.systemSearchResults = [];

      const menuComponent = this.getMenuComponent();
      if (!menuComponent) {
        console.log('AppComponent.onMenuSearchCleared - unable to get MenuComponent');
      } else if(menuComponent) {
        menuComponent.component.model.searchFieldValue = '';
        menuComponent.component.searchMode = false;
        this.expandPreviouslyOpenedMenus();
      }
    }
  }

  public onBusyComplete(event: SohoBusyIndicatorEvent) {
    // this.lmLoggerService.log([ this, 'onBusyComplete()', event ]);

    if (this.uiLoadingIndicatorTimeout > 0 ) {
      this.removeMingleStartModeOverlay();
    }
  }

  roleSelected() {
    // This event is fired by menu v2 and v1 only for closeSwitcherPanel.
    if (!this.lmContextService.isApplicationMenuV3()) {
      this.lmApplicationMenuService.clearExpandedMenus();

      if (!this.sohoApplicationMenuComponent) {
        console.log('AppComponent.roleSelected: cannot close role switcher: this.sohoApplicationMenuComponent is undefined');
        return;
      }
      this.sohoApplicationMenuComponent.closeSwitcherPanel();
    }
    // Additionally, this event is fired to reset breadcrumbs after a role switch in v3
    if (this._bannerHeaderComponent) {
      this._bannerHeaderComponent.resetBreadCrumbs(this.lmContextService.getWebApp() + '.home');
    }
  }

  private removeMingleStartModeOverlay() {
    if (this.inMingle && this.lmContextUtilService.hasStartModeCompleted()) {
      const startModeOverlayElement = document.getElementById('mingleStartModeOverlay');
      if (startModeOverlayElement) {
        startModeOverlayElement.style.display = 'none';
      }
    }
  }

  private setPersonalizations() {
    const globalPersonalization: LMGlobalPersonalization = this.lmGlobalPersonalizationService.getGlobalPersonalization();

    this.lmThemeService.getThemeChangeSubject().subscribe(themeId => {
      const id = themeId ? themeId: globalPersonalization.theme;
      this.updateThemeIcons(id as LMThemeId);
    });

    const accessibilityMode = globalPersonalization.accessibilityMode === undefined ? true : globalPersonalization.accessibilityMode;
    this.applyColorToMenu = globalPersonalization.applyColorToMenu || false;
    const useCompactFormLayout = globalPersonalization.useCompactFormLayout === undefined ?
      this.lmContextService.getCompactnessMode() === 'compact' : globalPersonalization.useCompactFormLayout;

    const context = this.lmContextService.getContext();
    if (context.theme || context.color) { // Use ming.le/portal theme/color if it exits and isn't default
      let theme = globalPersonalization.theme;
      let color = globalPersonalization.color;
      if (context.theme && context.theme !== 'Light') {
        theme = context.theme as LMThemeId;
      }
      if (context.color && context.color !== 'default') {
        color = context.color as LMColorId;
      }
      this.lmThemeService.setThemeAndColor(theme as LMThemeId, color as LMColorId, useCompactFormLayout);
    } else {
      this.lmThemeService.setThemeAndColor(globalPersonalization.theme, globalPersonalization.color, useCompactFormLayout);
    }

    // if not in Ming.le/Portal and theme/color were never set, then set them to what setThemeAndColor chose by default
    if (!context.theme) {
      if (context.theme || this.lmThemeService.isCurrentThemeDefault()) {
        delete globalPersonalization.theme;
      } else {
        globalPersonalization.theme = this.lmThemeService.getCurrentThemeId();
      }
    }
    if (!context.color) {
      globalPersonalization.color = this.lmThemeService.getCurrentColorId();
    }
    globalPersonalization.useCompactFormLayout = useCompactFormLayout;
    globalPersonalization.accessibilityMode = accessibilityMode;
    // Have to save for other components retrieving from global personalization
    this.lmGlobalPersonalizationService.saveGlobalPersonalization(globalPersonalization);
  }

  private isPreferredWebApp(): boolean {
    // Check if the user is navigating to a preferred webapp after mingle plugin loads app component
    const context = this.lmContextService.getContext();
    const isDefaultWebApp = context.webApp === 'web';

    // Not Collapsed for any webapp other than web
    if (!isDefaultWebApp) {
      return true; // Not web webapp
    }

    // Check if UIDefaultSuiteHomePage or a preferred webapp in roaming user profile is set
    const currentRoute = this.getRouteComponent();
    if (currentRoute !== undefined && currentRoute instanceof LMSuiteHomeComponent) {
      return ((currentRoute as LMSuiteHomeComponent).hasDefaultStartPage); //Not web webapp
    }

    // Collapsed for web
    return false; // web webapp
  }


  private setMenuPersonalization() {
    const bannerPersonalization: LMGlobalPersonalization = this.lmGlobalPersonalizationService.getGlobalPersonalization();

    if (this.lmContextService.isAnonymousUser() || !this.isPreferredWebApp()) {
      // Initial state for anonymous and guest user is set to collapsed by this.getInitialModuleNavDisplayMode
      // Initial state for web/home should be collapsed
      if (this.moduleNavDisplayMode) {
        this.updateDisplayMode('collapsed');
      }

      this.openOnLarge = false;
      return;
    }

    if (!isEmpty(bannerPersonalization) && bannerPersonalization.moduleNavDisplayMode !== undefined) {
      if (bannerPersonalization.moduleNavDisplayMode) {
        this.moduleNavDisplayMode = bannerPersonalization.moduleNavDisplayMode;
      }
    } else {
      bannerPersonalization.moduleNavDisplayMode = this.moduleNavDisplayMode;
      this.lmGlobalPersonalizationService.saveGlobalPersonalization(bannerPersonalization);
    }

    if (!isEmpty(bannerPersonalization) && bannerPersonalization.isMenuOpen !== undefined) {
      if (bannerPersonalization.isMenuOpen) {
        if (this.sohoApplicationMenuComponent && !this.sohoApplicationMenuComponent.isOpen()) {
          this.openOnLarge = true;
        }
      } else {
        if (this.sohoApplicationMenuComponent && this.sohoApplicationMenuComponent.isOpen()) {
          this.openOnLarge = false;
        }
      }
    } else {
      const openOnLarge = true;
      if (this.sohoApplicationMenuComponent) {
        this.openOnLarge = openOnLarge;
      }

      bannerPersonalization.isMenuOpen = openOnLarge;
      this.lmGlobalPersonalizationService.saveGlobalPersonalization(bannerPersonalization);
    }
  }

  private isHeaderExpanded(header: any) {
    return header.nativeElement.getElementsByTagName('a')[ 0 ].getAttribute('aria-expanded') === 'true';
  }

  public onHasHeaderTabs(hasHeaderTabs: boolean) {
    this.hasHeaderTabs = hasHeaderTabs;
  }

  public onHasBreadcrumbs(hasBreadcrumbs: boolean) {
    this.hasBreadcrumbs = hasBreadcrumbs;
    this.lmContextService.setIsBreadCrumbsDisplayed(hasBreadcrumbs);
  }

  public onAppMenuTriggerEvent() {
    if (this.sohoApplicationMenuSearchComponent && this.sohoApplicationMenuSearchComponent.isOpen()) {
      this.onMenuSearchCleared();
    }

    if (this.sohoModuleNavComponent) {
      this.onMenuSearchCleared();
      this.getMenuComponent()?.moduleNavSwitcher?.roleDropdownAPI()?.enable();

      this.handleV3NavComponent();
    }
  }

  public handleV3NavComponent() {
    if (this.sohoModuleNavComponent) {
      const globalPersonalization = this.lmGlobalPersonalizationService.getGlobalPersonalization();
      const moduleNavDisplayMode = globalPersonalization.moduleNavDisplayMode;
      this.updateDisplayMode(moduleNavDisplayMode === 'expanded' ? 'collapsed' : 'expanded');
      this.sohoModuleNavComponent.updated();

      if (this.moduleNavDisplayMode === 'expanded') {
        setTimeout(() => this.expandPreviouslyOpenedMenus());
      }
    }
  }

  private loadGlobalState() {
    if (this.lmContextService.disablePageState()) {
      this.globalState = {};
      return;
    }

    this.globalState = this.lmGlobalStateService.getGlobalState();
  }

  private saveGlobalState() {
    this.lmGlobalStateService.saveGlobalState(this.globalState);
  }

  /**
   * Sync web app was copied to lmApplicationMenuService
   * Functionality is the same
   * @param url
   * @private
   */
  private syncWebappMenu(url: string) {
    const menuComponent = this.getMenuComponent();
    if (!menuComponent) {
      console.log('AppComponent.syncWebappMenu - unable to get MenuComponent');
      return;
    }

    if (this.lmContextService.isApplicationMenuV2()) {
      this.lmApplicationMenuService.syncWebappMenu(url, menuComponent.component as LMApplicationMenuV2Component);
    } else if (this.lmContextService.isApplicationMenuV3()) {
      this.lmApplicationMenuService.syncWebappMenu(url, menuComponent.component as LMApplicationMenuV3Component);
    } else {
      this.lmApplicationMenuService.syncWebappMenu(url, menuComponent.component as LMApplicationMenuV1Component);
    }
  }

  /**
   * Method used to switch between different application menu types
   * @private
   */
  private getMenuComponent(): AppMenuComponent | undefined {
    // New Application Menu
    if (this.lmContextService.isApplicationMenuV2()) {
      if (!this.applicationMenuV2Component) {
        return undefined;
      }
      return {
        version: 'v2',
        component: this.applicationMenuV2Component,
        header: this.applicationMenuV2Component.webAppMenuHeader,
        loadWebAppMenu: this.applicationMenuV2Component.loadWebAppMenu,
        moduleNavSwitcher: null
      };
    }

    if (this.lmContextService.isApplicationMenuV3()) {
      if (!this.applicationMenuV3Component) {
        return undefined;
      }
      return {
        version: 'v3',
        component: this.applicationMenuV3Component,
        header: this.applicationMenuV3Component.webAppMenuHeader,
        loadWebAppMenu: this.applicationMenuV3Component.loadWebAppMenu,
        moduleNavSwitcher: this.applicationMenuV3Component.sohoModuleNavSwitcher
      };
    }

    // Original Banner Nav
    if (!this.applicationMenuV1Component) {
      return undefined;
    }

    return {
      version: 'v1',
      component: this.applicationMenuV1Component,
      header: this.applicationMenuV1Component.webAppMenuHeader,
      loadWebAppMenu: this.applicationMenuV1Component.loadWebAppMenu,
      moduleNavSwitcher: null
    };
  }

  private getSearchMenuComponent(): AppMenuSearchComponent | undefined {
    if (!this.applicationMenuSearchComponent) {
      return undefined;
    }

    return {
      version: this.lmContextService.applicationMenuVersion(),
      component: this.applicationMenuSearchComponent
    };
  }

  public onExpandSohoModuleNav(): void {
    if (this.sohoModuleNavComponent) {
      this.moduleNavDisplayMode = 'expanded';
      this.updateDisplayMode(this.moduleNavDisplayMode);
    }
  }

  public onCollapseSohoModuleNav(): void {
    if (this.sohoModuleNavComponent) {
      this.moduleNavDisplayMode = 'collapsed';
      this.updateDisplayMode(this.moduleNavDisplayMode);
    }
  }

  public onHomeClicked() {
    if (this.sohoModuleNavComponent) {
      this.sohoModuleNavComponent.accordionAPI()?.collapseAll();
    }
  }

  public handleDisplayModeChange(e: SohoModuleNavDisplayModeChangeEvent): void {
    this.updateDisplayMode(e.val);
  }

  public updateDisplayMode(displayMode: SohoModuleNavDisplayMode): void {
    const globalPersonalization = this.lmGlobalPersonalizationService.getGlobalPersonalization();
    globalPersonalization.moduleNavDisplayMode = displayMode;

    this.lmGlobalPersonalizationService.saveGlobalPersonalization(globalPersonalization);
    this.moduleNavDisplayMode = displayMode;
  }

  private getInitialModuleNavDisplayMode(): SohoModuleNavDisplayMode {

    if (this.lmContextService.isAnonymousUser()
      || this.lmContextService.allowAnonymousAccess()
      || this.lmContextService.isGuestUser()
    ) {
      return this.lmContextService.isMobileDevice() ? false : 'collapsed';
    }

    return this.lmContextService.isMobileDevice() ? false : 'expanded';
  }
}
